import styles from './Button.module.scss';
import { Loader } from './components';

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  testId: string;
  size?: number;
  variant?:
    | 'actionPrimary'
    | 'actionSecondary'
    | 'neutralSecondary'
    | 'negativeSecondary'
    | 'premiumPrimary'
    | 'premiumSecondary'
    | 'premiumGradient';
  subTitle?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const Button = ({
  testId,
  size = 500,
  variant = 'actionPrimary',
  children,
  loading,
  subTitle,
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={`${styles.button} ${props.className || ''}`}
      type={props.type || 'button'}
      data-test-id={`${testId}-container`}
      data-size={size}
      data-variant={variant}
      data-disabled={props.disabled}
      data-loading={loading}
    >
      {!loading && (
        <>
          {children}
          <br />
          {subTitle && (
            <span
              className={styles.subTitle}
              data-test-id={`${testId}-subtitle`}
            >
              {subTitle}
            </span>
          )}
        </>
      )}
      {loading && (
        <Loader className={styles.loader} data-test-id={`${testId}-loader`} />
      )}
    </button>
  );
};
